import ActivityUserAnswerModel from '../Apis/ActivityUserAnswer'
import Controller from './Controller'

export default class ActivityUserAnswerController extends Controller {
  constructor() {
    super(new ActivityUserAnswerModel())
  }
  async report(params) {
    const data = await this.model.report(params)
    return data
  }
}
